import { useSelector } from "react-redux";

import { selectFlagById } from "store/slices/featureFlags";
import type { defaults } from "store/slices/featureFlags";
import type { FlagsState } from "store/slices/featureFlags/slice";

export function useFeatureFlag<T extends keyof typeof defaults>(flagId: T) {
  return useSelector((state: FlagsState) =>
    selectFlagById(state, flagId),
  ) as (typeof defaults)[T] extends boolean ? boolean : (typeof defaults)[T];
}
